<script>
  // Buyer's "Your card" page (/s/:id?k=) for support: open it, copy the link, or
  // draft the canned "here's your card page" email in one click. The key is
  // stored on the ecard doc; cards without one (none since the backfill) show nothing.
  import { ecardBase } from '../lib/stores.js';
  export let ecard;                // { id, cardPageKey, recipientName, customerEmail, purchaserFirstName }
  export let customerEmail = null; // override (order page passes the Shopify order email)
  export let customerFirstName = null;
  export let compact = false;

  $: url = ecard && ecard.cardPageKey ? `${$ecardBase}/s/${ecard.id}?k=${ecard.cardPageKey}` : null;
  $: to = customerEmail || ecard?.customerEmail || '';
  $: firstName = customerFirstName || ecard?.purchaserFirstName || '';
  $: mailto = url ? buildMailto() : null;

  function buildMailto() {
    const who = ecard.recipientName ? ` to ${ecard.recipientName}` : '';
    const subject = `Your Card Hero ecard${who} – your card page`;
    const body = [
      `Hi${firstName ? ' ' + firstName : ''},`,
      '',
      `Here's the link to your card page for your ecard${who}. From there you can see when it's being sent and whether it's been opened, copy the link to share it yourself, or preview the card:`,
      '',
      url,
      '',
      "Keep this email – it's your way back to your card.",
      '',
      'Kind regards,',
      'Card Hero',
    ].join('\n');
    return `mailto:${encodeURIComponent(to)}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  }

  let copied = false;
  async function copy() {
    try {
      await navigator.clipboard.writeText(url);
      copied = true;
      setTimeout(() => { copied = false; }, 1500);
    } catch (e) { /* clipboard blocked — the link is still openable */ }
  }
</script>

{#if url}
  <span class="cpl" class:compact>
    <a href={url} target="_blank" rel="noopener" title="The buyer's own page: delivery status, share link, purchaser-tagged preview">Card page ↗</a>
    <button type="button" on:click={copy} title="Copy the card page link">{copied ? '✓ copied' : '⧉ copy'}</button>
    <a href={mailto} title={to ? `Draft the 'here's your card page' email to ${to}` : 'No buyer email on this card — the draft opens with an empty To'}>✉️ email link</a>
  </span>
{/if}

<style>
  .cpl { display: inline-flex; flex-wrap: wrap; gap: .5rem; align-items: center; font-size: .85rem; }
  .cpl.compact { font-size: .78rem; gap: .4rem; }
  .cpl a { color: #1d4ed8; text-decoration: none; }
  .cpl a:hover { text-decoration: underline; }
  .cpl button { border: 1px solid #ccc; background: #fff; border-radius: 4px; padding: .1rem .4rem; font: inherit; cursor: pointer; color: #333; }
  .cpl button:hover { background: #f3f4f6; }
</style>
